import React, { useState, useEffect } from "react";
import { all_routes } from "Router/all_routes";
import { Save } from "react-feather";
import { useNavigate } from "react-router-dom";
import ToastNotification from "Components/UI/ToastNotification";
import Input from "Components/UI/Input";
import { useForm, FormProvider, Controller } from "react-hook-form";
import { useGetEmployeeQuery } from "AppQuries/employee/employee_list";
import { useGetEmployeeLeaveQuery } from "AppQuries/leave/get-employee-leaves";
import Select from "react-select";
import { applyLeaveValidationSchema } from "core/Operations/ValidationSchema/leaveValidaitionSchema";
import { yupResolver } from "@hookform/resolvers/yup";
import { useSaveApplyLeaveMutation } from "AppQuries/leave/apply-leave";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { getCurrentFormattedDate } from "core/Operations/currentDateTime";
import { checkIsPublicHoliday } from "core/Operations/attendance/checkPublicHoliday";
import { useGetPublicHolidaysQuery } from "AppQuries/leave/public-holiday/public-holiday";
import moment from "moment";
import { toast } from "core/Operations/toast";
import ImageUploader from "Components/UI/ImageUploder";
import ApplyLeaveDayDetails from "./ApplyLeave/ApplyLeaveDayDetails";
import ImageCropper from "Components/UI/Image/ImageCropper";
import ImageCropperFile from "Components/UI/Image/ImageCropperFile";
const isPaidOption = [
  { id: 1, label: "Yes", value: true },
  { id: 0, label: "No", value: false },
];

const isApprovedOption = [
  { id: 1, label: "Yes", value: 1 },
  { id: 0, label: "No", value: 0 },
];

const ApplyLeave = () => {
  const userData = useSelector(loggedInUser);
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);

  const { data: employees } = useGetEmployeeQuery({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
  });

  const { data: publicHolidays } = useGetPublicHolidaysQuery({
    companyCode: userData?.companyCode,
  });
  const navigate = useNavigate();

  const employeeOptions =
    employees
      ?.filter((d) => d.isActive)
      ?.map((o) => ({
        id: o.employeeCode,
        label: `${o.uniqueId} - ${o.fullName}`,
        value: o.employeeCode,
      })) || [];

  const methods = useForm({
    resolver: yupResolver(applyLeaveValidationSchema),
    defaultValues: {
      companyCode: userData?.companyCode,
      headerID: 0,
      leaveCode: 0,
      leaveId: 0,
      includePublicHoliday: true,
      // isPaidLeave: true,
      // isApproved: 1,
      approvedBy: "",
      approvedDate: "",
      createUser: userData?.userName,
      locationCode: userData?.locationCode,
      details: [],
    },
  });
  const {
    setValue,
    watch,
    handleSubmit,
    trigger,
    getValues,
    control,
    formState: { errors },
  } = methods;

  const [employeeleaveTypes, setEmployeeLeaveTypes] = useState([]);
  const [leaveTypeOptions, setEmployeeLeaveOptions] = useState([
    {
      id: 0,
      label: "Select Leave",
      value: 0,
    },
  ]);
  // Only call the hook when employeeCode is available to avoid unnecessary triggers
  const employeeCode = watch("employeeCode");
  const { data: leaveTypes, refetch } = useGetEmployeeLeaveQuery(
    {
      companyCode: userData?.companyCode,
      employeeCode,
      locationCode: userData?.locationCode,
    },
    { enabled: !!employeeCode }
  );

  const {
    mutate: applyLeave,
    isLoading,
    isPending,
    isError,
    error,
  } = useSaveApplyLeaveMutation();

  // const calculateLeaveDays = (startDate, endDate) => {
  //   const start = new Date(startDate);
  //   const end = new Date(endDate);
  //   let holidays = 0;
  //   const selectedEmployee = employees?.data?.find(
  //     (e) => e.employeeCode === watch("employeeCode")
  //   );

  //   if (!getValues("includePublicHoliday")) {
  //     const restData = selectedEmployee?.restDay?.split(",") || [];
  //     for (
  //       let date = new Date(start);
  //       date <= end;
  //       date.setDate(date.getDate() + 1)
  //     ) {
  //       const fullRestDay = restData
  //         .filter((v) => v.includes("-1"))
  //         .map((d) => d?.split("-")[0]);

  //       console.log("fullRestDay", fullRestDay);

  //       const halfRestDay = restData
  //         .filter((v) => v.includes("-0.5"))
  //         .map((d) => d?.split("-")[0]);

  //       const day = moment(date).format("dddd");

  //       const isRestDay =
  //         Array.isArray(fullRestDay) && fullRestDay.includes(day);
  //       const isHalfRestDay =
  //         Array.isArray(halfRestDay) && halfRestDay.includes(day);

  //       if (
  //         checkIsPublicHoliday(
  //           publicHolidays,
  //           format(new Date(date), "yyyy-MM-dd")
  //         ) ||
  //         isRestDay
  //       ) {
  //         holidays++;
  //       } else if (isHalfRestDay) {
  //         holidays = holidays + 0.5;
  //       }
  //     }
  //   }

  //   if (!isNaN(start) && !isNaN(end) && start <= end) {
  //     const difference = Math.ceil((end - start) / (1000 * 60 * 60 * 24)) + 1;
  //     setValue("noOfDays", difference - holidays);

  //     if (difference > getValues("balanceLeave")) {
  //       setValue("isPaidLeave", false);
  //     } else {
  //       setValue("isPaidLeave", true);
  //     }
  //   } else {
  //     setValue("noOfDays", 0);
  //   }
  // };

  const calculateLeaveDays = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const selectedEmployee = employees?.find(
      (e) => e.employeeCode === watch("employeeCode")
    );

    const validLeaveDates = [];

    if (!isNaN(start) && !isNaN(end) && start <= end) {
      const restData = selectedEmployee?.restDay?.split(",") || [];

      const fullRestDay = restData
        .filter((v) => v.includes("-1"))
        .map((d) => d?.split("-")[0]);
      const halfRestDay = restData
        .filter((v) => v.includes("-0.5"))
        .map((d) => d?.split("-")[0]);

      for (
        let date = new Date(start);
        date <= end;
        date.setDate(date.getDate() + 1)
      ) {
        const currentDate = new Date(date);
        const dayName = moment(currentDate).format("dddd");
        const formattedDate = format(currentDate, "yyyy-MM-dd");

        const isPublicHoliday = checkIsPublicHoliday(
          publicHolidays,
          formattedDate
        );
        const isRestDay = fullRestDay.includes(dayName);
        const isHalfRestDay = halfRestDay.includes(dayName);

        if (
          (!getValues("includePublicHoliday") && isPublicHoliday) ||
          isRestDay
        ) {
          continue; // Skip full holidays/rest days
        }

        validLeaveDates.push({
          date: formattedDate,
          isHalfDay: false, // isHalfRestDay, // use when the half day feature is implemented
        });
      }

      const totalLeaveDays = validLeaveDates.reduce(
        (sum, d) => sum + (d.isHalfDay ? 0.5 : 1),
        0
      );

      setValue("noOfDays", totalLeaveDays);
      setValue("selectedLeaveDates", validLeaveDates); // Store for useEffect

      setValue("isPaidLeave", totalLeaveDays <= getValues("balanceLeave"));
    } else {
      setValue("noOfDays", 0);
      setValue("selectedLeaveDates", []);
    }
  };
  const onSubmit = (payload) => {
    // if (payload.isApproved) {
    //   payload.approvedBy = userData?.userName;
    //   payload.approvedDate = getCurrentFormattedDate();
    // }

    const requestData = new FormData();
    requestData.append("file", selectedFile);
    requestData.append("data", JSON.stringify(payload));

    applyLeave(requestData, {
      onSuccess: (data) => {
        if (data[0].response === true) {
          toast.success(data[0].errorMessage || "Leave Applied Successfully.");
          setTimeout(() => {
            navigate(`${all_routes.leave}${all_routes.leave_manangement}`);
          }, 1000);
        } else {
          toast.warning(data[0].errorMessage || "Something went wrong.");
        }
      },
      onError: (error) => {
        toast.error(error.message || "Something went wrong.");
      },
    });
  };

  const selectEmployeeHandler = (e) => {
    const employeeCode = e;
    const selectedEmployee = employees?.data.find(
      (d) => d.employeeCode === employeeCode
    );
    setValue("employeeCode", employeeCode);
    setValue("companyCode", selectedEmployee?.companyCode);
  };

  const selectLeaveHandler = (selectedOption) => {
    const selectedLeave =
      employeeleaveTypes.find((d) => d.leaveCode === selectedOption) || {};

    setValue("leaveCode", selectedLeave.leaveCode || 0);
    setValue("totalLeaveDays", selectedLeave.totalLeaveDays || 0);
    setValue("allotedLeave", selectedLeave.noOfAllotedDays);
    setValue("prevNoOfDays", Number(selectedLeave.leaveTaken));
    setValue("balanceLeave", selectedLeave.balanceLeaveDays);
    setValue("noOfAppliedLeave", selectedLeave.noOfAppliedLeave);
    setValue("approvedLeaves", selectedLeave.approvedLeaves);
    setValue("pendingLeaves", selectedLeave.pendingLeaves);
    setValue("rejectedLeaves", selectedLeave.rejectedLeaves);
    setValue("noOfDays", 0);
    setValue("leaveFrom", "");
    setValue("leaveTo", "");
    setValue("details", []);
  };

  useEffect(() => {
    const fetchLeaves = async () => {
      const { data: leaves } = await refetch();

      setEmployeeLeaveTypes(leaves?.data || []);

      const leaveOptions =
        leaves?.data?.map((o) => ({
          id: o.code,
          label: o.leaveName,
          value: o.leaveCode,
        })) || [];
      setEmployeeLeaveOptions([
        { id: 0, label: "Select Leave", value: 0 },
        ...leaveOptions,
      ]);
    };
    if (watch("employeeCode")) fetchLeaves();

    setValue("leaveCode", 0);
    setValue("leaveFrom", null);
    setValue("leaveTo", null);
  }, [watch("employeeCode")]);

  useEffect(() => {
    if (getValues("leaveFrom") && getValues("leaveTo"))
      calculateLeaveDays(getValues("leaveFrom"), getValues("leaveTo"));
  }, [watch("leaveFrom"), watch("leaveTo"), watch("includePublicHoliday")]);

  useEffect(() => {
    const selectedDates = watch("selectedLeaveDates") || [];
    let totalLeaveDays = 0;
    if (watch("leaveCode") !== 0 && selectedDates.length > 0) {
      const leaveDetails = selectedDates.map((entry) => {
        totalLeaveDays = totalLeaveDays + entry.isHalfDay ? 0.5 : 1;
        return {
          companyCode: watch("companyCode"),
          leaveId: 0,
          employeeCode: watch("employeeCode"),
          leaveFrom: entry.date,
          leaveTo: entry.date,
          noOfDays: entry.isHalfDay ? 0.5 : 1,
          isHalfDay: entry.isHalfDay,
          isPaidLeave: totalLeaveDays <= getValues("balanceLeave"), // totalLeaveDays <= watch("balanceLeave"),
          isApproved: 0,
          approvedBy: "",
          approvedDate: "",
          enablePaidLeave: watch("balanceLeave") > 0,
        };
      });

      console.log("leaveDetails", leaveDetails);

      setValue("details", leaveDetails);
    }
  }, [watch("selectedLeaveDates")]);

  // useEffect(() => {
  //   if (watch("leaveCode") !== 0 && watch("noOfDays") > 0) {
  //     const leaveDetails = Array.from({ length: watch("noOfDays") }).map(
  //       (_, i) => ({
  //         companyCode: watch("companyCode"),
  //         leaveId: 0,
  //         employeeCode: watch("employeeCode"),
  //         leaveFrom:
  //           i === 0
  //             ? watch("leaveFrom")
  //             : format(
  //                 new Date(watch("leaveFrom")).setDate(
  //                   new Date(watch("leaveFrom")).getDate() + i
  //                 ),
  //                 "yyyy-MM-dd"
  //               ),
  //         leaveTo:
  //           i === 0
  //             ? watch("leaveFrom")
  //             : format(
  //                 new Date(watch("leaveFrom")).setDate(
  //                   new Date(watch("leaveFrom")).getDate() + i
  //                 ),
  //                 "yyyy-MM-dd"
  //               ),
  //         noOfDays: 1,
  //         isHalfDay: false,
  //         isPaidLeave: false,
  //         isApproved: 0,
  //         approvedBy: "",
  //         approvedDate: "",
  //         enablePaidLeave: watch("balanceLeave") >= 1 ? true : false,
  //       })
  //     );
  //     setValue("details", leaveDetails);
  //     console.log("leaveDetails", leaveDetails);
  //   }
  // }, [watch("noOfDays")]);

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <FormProvider {...methods}>
            <form
              onSubmit={handleSubmit(onSubmit)}
              className="needs-validation"
              noValidate=""
            >
              <div className="page-header">
                <div className="add-item d-flex">
                  <div className="page-title">
                    <h4>Apply Leave</h4>
                    <h6>Apply leave request for employees</h6>
                  </div>
                </div>
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="Back">Back</Tooltip>}
                  >
                    <button
                      className="btn btn-secondary me-md-2"
                      type="button"
                      //   disabled={isLoading}
                      onClick={() =>
                        navigate(
                          `${all_routes.leave}${all_routes.leave_manangement}`
                        )
                      }
                    >
                      <i className="fas fa-reply me-2"></i>
                      Back
                    </button>
                  </OverlayTrigger>
                </div>
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="Save">Save</Tooltip>}
                  >
                    <button
                      type="submit"
                      className="btn btn-added"
                      //   disabled={isLoading}
                    >
                      {/* {isLoading ? (
                    <>
                      <i className="fas fa-spinner fa-spin me-2" /> Loading...
                    </>
                  ) : (
                    <>
                      <Save className="me-2" />
                      Save
                    </>
                  )} */}
                      <Save className="me-2" />
                      Save
                    </button>
                  </OverlayTrigger>
                </div>
              </div>
              {watch("leaveCode") !== 0 && (
                <div className="leave-section">
                  <div className="row">
                    <div className="col-lg-2 col-sm-6 col-12 d-flex">
                      <div className="dash-count">
                        <div className="dash-counts ">
                          <h4 className="text-center">
                            {watch("allotedLeave") || 0}
                          </h4>
                          <h5 className="text-center">Total Leaves</h5>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-2 col-sm-6 col-12 d-flex">
                      <div className="dash-count das1">
                        <div className="dash-counts ">
                          <h4 className="text-center">
                            {watch("balanceLeaveDays") || 0}
                          </h4>
                          <h5 className="text-center">Availables</h5>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-2 col-sm-6 col-12 d-flex">
                      <div className="dash-count das2">
                        <div className="dash-counts ">
                          <h4 className="text-center">
                            {watch("noOfAppliedLeave") || 0}
                          </h4>
                          <h5 className="text-center">Applied</h5>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-2 col-sm-6 col-12 d-flex">
                      <div className="dash-count das3">
                        <div className="dash-counts ">
                          <h4 className="text-center">
                            {watch("prevNoOfDays") || 0}
                          </h4>
                          <h5 className="text-center">Approved</h5>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-2 col-sm-6 col-12 d-flex">
                      <div className="dash-count das4">
                        <div className="dash-counts ">
                          <h4 className="text-center">
                            {watch("pendingLeaves") || 0}
                          </h4>
                          <h5 className="text-center">Pending</h5>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-2 col-sm-6 col-12 d-flex">
                      <div className="dash-count das5">
                        <div className="dash-counts ">
                          <h4 className="text-center">
                            {watch("rejectedLeaves") || 0}
                          </h4>
                          <h5 className="text-center">Rejected</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className="row">
                <div className="col-md-12">
                  {errors?.details && (
                    <div className="alert alert-warning" role="alert">
                      <strong>Note:</strong> {errors?.details?.message}
                    </div>
                  )}
                </div>
                <div className="col-md-12">
                  <div className="card border-0">
                    <div className="card-header">
                      <h4 className="card-title">Apply Leave Form</h4>
                    </div>
                    <div className="card-body">
                      <div className="form-row row">
                        <div className="col-md-4 col-sg-12 mb-3">
                          <Input
                            name="employeeCode"
                            type="commonSelect"
                            placeholder=""
                            className={`form-control ${
                              errors.employeeCode ? "is-invalid" : ""
                            }`}
                            label="Employee"
                            labelClassName="form-label"
                            optionData={employeeOptions}
                            required={true}
                            requiredMessage="Employee is required"
                            onChange={selectEmployeeHandler}
                            defaultValue={watch("employeeCode")}
                            showSearch={true}
                          />
                        </div>
                        <div className="col-md-4 col-sg-12 mb-3">
                          {/* <div className="form-label">
                            Leave Type <span className="asterisk">*</span>
                          </div> */}
                          <Input
                            name="leaveCode"
                            type="commonSelect"
                            placeholder=""
                            className={`form-control ${
                              errors.leaveCode ? "is-invalid" : ""
                            }`}
                            label="Leave Type"
                            labelClassName="form-label"
                            optionData={leaveTypeOptions}
                            required={true}
                            requiredMessage="leave type is required"
                            onSelect={selectLeaveHandler}
                            defaultValue={watch("leaveCode")}
                          />
                          {/* <Controller
                            name=""
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                              <Select
                                {...field}
                                options={leaveTypeOptions}
                                placeholder="Select Leave Type"
                                className={`select ${
                                  errors.leaveCode ? "is-invalid" : ""
                                }`}
                                value={leaveTypeOptions.find(
                                  (option) => option.value === field.value
                                )}
                                onChange={}
                              />
                            )}
                          />
                          {errors.leaveCode && (
                            <div className="invalid-feedback">
                              {errors?.leaveCode?.message || "Invalid input"}
                            </div>
                          )} */}
                        </div>
                        <div className="col-md-4 col-sg-12 mb-3">
                          <Input
                            name="requestDate"
                            type="date"
                            placeholder="Request Date"
                            className={`form-control ${
                              errors.requestDate ? "is-invalid" : ""
                            }`}
                            label="Request Date"
                            labelClassName="form-label"
                            required={true}
                            requiredMessage="request is required"
                            defaultValue=""
                            dateFormat="YYYY-MM-DD"
                          />
                        </div>
                        <div className="col-md-4 col-sg-12 mb-3">
                          <Input
                            name="leaveFrom"
                            type="date"
                            placeholder="Leave From"
                            className={`form-control ${
                              errors.leaveFrom ? "is-invalid" : ""
                            }`}
                            label="Leave From"
                            labelClassName="form-label"
                            required={true}
                            requiredMessage="request date is required"
                            defaultValue=""
                            dateFormat="YYYY-MM-DD"
                          />
                        </div>
                        <div className="col-md-4 col-sg-12 mb-3">
                          <Input
                            name="leaveTo"
                            type="date"
                            placeholder="Leave To"
                            className={`form-control ${
                              errors.leaveTo ? "is-invalid" : ""
                            }`}
                            label="Leave To"
                            labelClassName="form-label"
                            required={true}
                            requiredMessage="leave To is required"
                            defaultValue=""
                            dateFormat="YYYY-MM-DD"
                          />
                        </div>
                        <div className="col-md-4 col-sg-12 mb-3">
                          <Input
                            name="includePublicHoliday"
                            type="commonSelect"
                            placeholder=""
                            className={`form-control ${
                              errors.includePublicHoliday ? "is-invalid" : ""
                            }`}
                            label="Include Public Holiday"
                            labelClassName="form-label"
                            optionData={isPaidOption}
                            required={false}
                            requiredMessage="Include Public Holiday is required"
                            onSelect={(selectedOption) =>
                              setValue("includePublicHoliday", selectedOption)
                            }
                            defaultValue={watch("includePublicHoliday")}
                          />
                        </div>
                        <div className="col-md-4 col-sg-12 mb-3">
                          <Input
                            name="noOfDays"
                            type="text"
                            placeholder="No of Days"
                            className={`form-control ${
                              errors.noOfDays ? "is-invalid" : ""
                            }`}
                            label="No of Days"
                            labelClassName="form-label"
                            required={true}
                            requiredMessage="No of Days is required"
                            defaultValue=""
                            readOnly={true}
                          />
                        </div>

                        {watch("leaveCode") !== 0 && watch("noOfDays") > 0 && (
                          <ApplyLeaveDayDetails />
                        )}

                        <div className="col-md-4 col-sg-12 mb-3">
                          <Input
                            name="reason"
                            type="text"
                            placeholder="Reason for Leave"
                            className={`form-control ${
                              errors.reason ? "is-invalid" : ""
                            }`}
                            label="Reason for Leave"
                            labelClassName="form-label"
                            required={true}
                            requiredMessage="Reason for Leave is required"
                            defaultValue=""
                          />
                        </div>
                        <div className="col-md-4 col-sg-12 mb-3">
                          <Input
                            name="allotedLeave"
                            type="text"
                            placeholder="Alloted Leave"
                            className={`form-control ${
                              errors.allotedLeave ? "is-invalid" : ""
                            }`}
                            label="Alloted Leave"
                            labelClassName="form-label"
                            required={true}
                            requiredMessage="Alloted Leave is required"
                            defaultValue=""
                            readOnly={true}
                          />
                        </div>
                        <div className="col-md-4 col-sg-12 mb-3">
                          <Input
                            name="balanceLeave"
                            type="text"
                            placeholder="Balance Leave"
                            className={`form-control ${
                              errors.balanceLeave ? "is-invalid" : ""
                            }`}
                            label="Balance Leave"
                            labelClassName="form-label"
                            required={true}
                            requiredMessage="Balance Leave is required"
                            defaultValue=""
                            readOnly={true}
                          />
                        </div>
                        <div className="col-md-4 col-sg-12 mb-3">
                          <Input
                            name="prevNoOfDays"
                            type="text"
                            placeholder="Leave Taken"
                            className={`form-control ${
                              errors.prevNoOfDays ? "is-invalid" : ""
                            }`}
                            label="Leave Taken"
                            labelClassName="form-label"
                            required={true}
                            requiredMessage="Leave Taken is required"
                            defaultValue=""
                            readOnly={true}
                          />
                        </div>
                        {/* <div className="col-md-4 col-sg-12 mb-3">
                          <Input
                            name="isApproved"
                            type="commonSelect"
                            placeholder=""
                            className={`form-control select ${
                              errors.isApproved ? "is-invalid" : ""
                            }`}
                            label="Is Approved"
                            labelClassName="form-label"
                            optionData={isApprovedOption}
                            required={true}
                            requiredMessage="Is Approved is required"
                            onChange={(selectedOption) => {
                              setValue("isApproved", selectedOption);
                              trigger("isApproved");
                            }}
                            defaultValue={watch("isApproved")}
                          />
                        </div>
                        <div className="col-md-4 col-sg-12 mb-3">
                          <Input
                            name="isPaidLeave"
                            type="commonSelect"
                            placeholder=""
                            className={`form-control select ${
                              errors.isPaidLeave ? "is-invalid" : ""
                            }`}
                            label="Is Paid"
                            labelClassName="form-label"
                            optionData={isPaidOption}
                            required={true}
                            requiredMessage="Is Paid is required"
                            onChange={(selectedOption) => {
                              setValue("isPaidLeave", selectedOption);
                              trigger("isPaidLeave");
                            }}
                            defaultValue={watch("isPaidLeave")}
                          />
                        </div> */}
                        {/* <div className="col-md-4 col-sg-12 mb-3">
                          <ImageUploader
                            base64Value={watch("imageAttachment")}
                            setBase64Value={(value) =>
                              setValue("imageAttachment", value)
                            }
                          />
                        </div> */}
                        <div className="col-md-4 col-sg-12 mb-3">
                          <ImageCropperFile
                            base64Value={previewImage}
                            setBase64Value={(base64, file) => {
                              setPreviewImage(base64); // preview
                              setSelectedFile(file); // like normal input
                            }}
                          />
                          {/* <input
                            type="file"
                            onChange={(e) => setSelectedFile(e.target.files[0])}
                          /> */}
                        </div>
                      </div>
                    </div>
                    {/* <div className="card-footer">
                      <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                        <button
                          className="btn btn-secondary me-md-2"
                          type="button"
                          // disabled={isLoading}
                          onClick={() =>
                            navigate(
                              `${all_routes.leave}${all_routes.leave_manangement}`
                            )
                          }
                        >
                          <i className="fas fa-reply me-2"></i>
                          Back
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary"
                          disabled={isLoading}
                        >
                          {isLoading ? (
                          <>
                            <i className="fas fa-spinner fa-spin me-2" />
                            Loading...
                          </>
                        ) : (
                          <>
                            <Save className="me-2" />
                            Save
                          </>
                          )}
                        </button>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </form>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};

export default React.memo(ApplyLeave);
